<div class="main_div">
    <video preload="true" controls="false" autoplay disablePictureInPicture controlsList="nodownload" id="videoBG" (ended)="myFunction()" type="video/mp4" playsinline oncontextmenu="return false" muted>
        <source src="{{first_video}}" type="video/mp4">
    </video>
</div>